module.exports = __webpack_public_path__ + "img/14.7bf6cb4d.jpg";